import { StitchDiamond } from "./icons";

const ITEMS = ["Hats", "Scarves", "Baby Blankets", "Throw Blankets", "Baby Booties", "Cardigans", "Amigurumi", "Stuffies", "Slippers", "Coaster Sets"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="marquee-mask overflow-hidden border-y border-[#E6DFD5] bg-[#F5F0E8] py-5">
      <div className="animate-marquee flex w-max items-center gap-8">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span className="whitespace-nowrap font-serif text-2xl font-medium italic text-[#2C2520]/70">{item}</span>
            <StitchDiamond className="h-2.5 w-2.5 text-[#C88A75]" />
          </span>
        ))}
      </div>
    </div>
  );
}
